<template>
  <router-link v-if="params.id" :to="link" :target="target">
    {{ formattedNumber }}{{ archivedLabel }}
  </router-link>
</template>

<script>
import { ClientRouteName } from '@/router/router.constants';
import { ObjectStatus } from '@/api/v2/requests/objects';
import { formatEntityNumber, EntityPrefix } from '@/util/entity-number';

export default {
  computed: {
    formattedNumber() {
      return formatEntityNumber(
        EntityPrefix.OBJECT,
        this.params.internalNumber,
      );
    },
    link() {
      if (this.params.offerId)
        return {
          name: ClientRouteName.OBJECT_IN_OFFER_DETAILS,
          params: { objectId: this.params.id, offerId: this.params.offerId },
        };

      return {
        name: ClientRouteName.OBJECT_DETAILS,
        params: {
          objectId: this.params.id,
          objectTypeId: this.params.objectTypeId,
        },
      };
    },
    target() {
      return this.params.offerId ? '' : '_blank';
    },
    isArchived() {
      return this.params.status === ObjectStatus.ARCHIVED;
    },
    archivedLabel() {
      return this.isArchived ? ` (${this.$t('common.archived')})` : '';
    },
  },
};
</script>
